<template>
  <div>
    <SuccessToastComponent :SuccessToast="SuccessToast" @close="close" />
    <ErrorToastComponent :ErrorToast="ErrorToast" @close="close" />

    <v-row>
      <v-col cols="12" md="6">
        <div>
          <h1>Edit Course</h1>
        </div>
      </v-col>
      <v-col cols="12" md="6"> </v-col>
    </v-row>

    <div class="my-9">
      <v-tabs v-model="tab" slider-color="transparent">
        <div
          class="d-flex"
          style="width: 100%; background: rgba(236, 241, 242, 1)"
        >
          <v-tab
            ripple
            href="#tab-1"
            @click="
              () => {
                this.tab == 'tab-1';
                this.continuebtn = true;
              }
            "
            ><span class="tabs_style text_style"> Content </span></v-tab
          >
          <v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-2"
            @click="
              () => {
                this.tab == 'tab-2';
                this.continuebtn = true;
              }
            "
          >
            <span class="tabs_style text_style"> Settings </span> </v-tab
          ><v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-3"
            @click="
              () => {
                this.tab == 'tab-3';
                this.continuebtn = true;
              }
            "
          >
            <span class="tabs_style text_style">
              Manuals/Royalties
            </span></v-tab
          >
          <v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-4"
            @click="
              () => {
                this.tab == 'tab-4';
                this.continuebtn = false;
              }
            "
          >
            <span class="tabs_style text_style"> Publish Preview </span>
          </v-tab>
        </div>
        <v-tab-item value="tab-1">
          <v-card-text>
            <div style="margin: 0 8.9vw">
              <v-text-field
                single-line
                flat
                style="font-size: 2rem; max-height: initial !important"
                label="Write your title here"
                height="60"
                hide-details=""
                v-model="$v.form.Title.$model"
              ></v-text-field>
              <div class="red--text" v-if="$v.form.Title.$error">
                Title is required
              </div>
              <v-textarea
                single-line
                counter
                maxlength="250"
                flat
                class="mt-4"
                v-model="$v.form.subHeading.$model"
                label="Write sub-heading description here "
              ></v-textarea>
              <div class="red--text" v-if="$v.form.subHeading.$error">
                Description is required
              </div>
              <div v-if="GetEditCourse">
                <blogimageuploader-component
                  @SetBanner="SetBanner"
                  @SetThumbnail="SetThumbnail"
                  @SetImage1="SetImage1"
                  @SetImage2="SetImage2"
                  @SetImage3="SetImage3"
                  :CourseImage="form"
                />
                <div class="red--text" v-if="$v.form.Banner.$error || $v.form.Thumbnail.$error">
                  Thumbnail and Banner are required
                </div>
              </div>

              <v-select
                class="mt-9"
                outlined
                v-model="form.filterCategory"
                :items="GetCourseCategories"
                item-value="Id"
                item-text="CategoryName"
                dense
                hide-details
                label="Category"
                multiple
                persistent-hint
                :menu-props="{ maxHeight: '400' }"
              ></v-select>
              <div class="red--text" v-if="$v.form.filterCategory.$error">
                Select one Category
              </div>

              <div class="mb-2 mt-6">
                <span style="font-size: 18px">
                  <b>Course Description</b>
                </span>
              </div>
              <div class="">
                <blogtextediter-component
                  :Content="form.Content"
                  @SetContent="SetContent"
                />
              </div>
              <div class="red--text" v-if="$v.form.Content.$error">
                Description is required
              </div>
            </div>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-card-text>
            <div style="margin: 0 8.9vw">
              <v-card
                class="my-6 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <div>
                  <span class="h1_tab2">Permissions </span>
                  <v-card class="mt-6" flat>
                    <v-select
                      class="pt-1"
                      multiple
                      :items="filteredMembership"
                      label="Permissions"
                      dense
                      single-line
                      outlined
                      hide-details=""
                      item-value="Id"
                      item-text="Name"
                      v-model="form.selectedPermissions"
                    ></v-select>
                  </v-card>
                  <div
                    class="red--text"
                    v-if="$v.form.selectedPermissions.$error"
                  >
                    Permissions are required
                  </div>
                </div>
                <div class="my-8">
                  <span class="h1_tab2">CEUs </span>
                  <v-card class="mt-6" flat>
                    <v-text-field
                      single-line
                      dense
                      hide-details
                      type="number"
                      outlined
                      v-model="form.CEUs"
                    ></v-text-field>
                  </v-card>
                  <div class="red--text" v-if="$v.form.CEUs.$error">
                    CEUs are required
                  </div>
                </div>
                <div>
                  <span class="h1_tab2">Display Order </span>
                  <v-card class="mt-6" flat>
                    <v-text-field
                      single-line
                      dense
                      hide-details
                      outlined
                      type="number"
                      v-model="form.DisplayOrder"
                    ></v-text-field>
                  </v-card>
                  <div class="red--text" v-if="$v.form.DisplayOrder.$error">
                    Display Order is required
                  </div>
                </div>
                <div class="mt-5">
                  <span class="h1_tab2">Member Discount </span>
                  <div
                    v-for="(selectOptions, index) in selectListone"
                    :key="index"
                  >
                    <v-row class="mt-2">
                      <v-col cols="12" md="4" class="">
                        <v-card class="mt-2" flat>
                          <v-select
                            class="pt-1"
                            v-model="selectOptions.MembershipId"
                            :items="userLevel"
                            item-value="id"
                            item-text="name"
                            label="Member Level"
                            dense
                            single-line
                            outlined
                            hide-details=""
                          ></v-select>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4" class="pb-0">
                        <v-card class="mt-2 d-flex align-center" flat>
                          <v-text-field
                            class=" "
                            label="USD Percentage off"
                            dense
                            single-line
                            type="number"
                            outlined
                            v-model="selectOptions.Percentage"
                            hide-details=""
                          ></v-text-field>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="2" class="pb-0">
                        <v-icon
                          style="cursor: pointer"
                          @click="RemoveRowMonitorDiscountone(index)"
                          color="red"
                          class="mt-3"
                          >mdi-delete</v-icon
                        >
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <v-btn
                  class="mt-3"
                  color="primary"
                  text
                  style="text-transform: none"
                  @click="addNewSelectone()"
                >
                  + Add Member Level
                </v-btn>

                <div class="mt-7">
                  <v-row>
                    <div class="mt-3">
                      <span class="h1_tab2"
                        >Monitor Discount (discount for Users retaking course)
                      </span>
                    </div>
                  </v-row>
                </div>
                <div class="mt-5">
                  <div
                    v-for="(selectOptions, index) in selectList"
                    :key="index"
                  >
                    <v-row class="mt-2">
                      <v-col cols="12" md="4" class="">
                        <v-card class="mt-2" flat>
                          <v-select
                            class="pt-1"
                            v-model="selectOptions.MembershipId"
                            :items="userLevel"
                            item-value="id"
                            item-text="name"
                            label="Member Level"
                            dense
                            single-line
                            outlined
                            hide-details=""
                          ></v-select>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4" class="pb-0">
                        <v-card class="mt-2 d-flex align-center" flat>
                          <v-text-field
                            class=" "
                            label="USD Percentage off"
                            dense
                            single-line
                            outlined
                            type="number"
                            v-model="selectOptions.Percentage"
                            hide-details=""
                          ></v-text-field>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="2" class="pb-0">
                        <v-icon
                          style="cursor: pointer"
                          @click="RemoveRowMonitorDiscount(index)"
                          color="red"
                          class="mt-3"
                          >mdi-delete</v-icon
                        >
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <v-btn
                  class="mt-3"
                  color="primary"
                  text
                  style="text-transform: none"
                  @click="addNewSelect(index)"
                >
                  + Add Member Level
                </v-btn>
                <div class="my-5 d-flex align-center">
                  <span class="h1_tab2">Is Beginner ? </span>
                  <v-card class="ml-3" flat>
                    <v-switch
                      style="background: #fbfbff"
                      v-model="form.IsBeginner"
                    ></v-switch>
                  </v-card>
                </div>

                <div class="my-5">
                  <span class="h1_tab2">Graduation Template </span>

                  <v-card class="mt-6" flat>
                    <v-select
                      v-model="form.GraduationTemplate"
                      class="pt-1"
                      :items="GraduationTemplateArray"
                      menu-props="auto"
                      dense
                      single-line
                      outlined
                      hide-details=""
                      return-object
                    ></v-select>
                  </v-card>
                  <div
                    class="red--text"
                    v-if="$v.form.GraduationTemplate.$error"
                  >
                    Graduation Template is required
                  </div>
                </div>

                <!--------------------- Livestream Dialog-------------------------------------------->
                <v-dialog v-model="LivestreamDialog" max-width="590" persistent>
                  <v-card class="px-8 py-4">
                    <div class="heading-1">Create Live stream</div>

                    <div class="my-4">
                      <v-text-field
                        label="Enter live stream link"
                      ></v-text-field>
                      <div class="my-6">
                        <!------------------------Upload Video Thumbnail------------------>
                        <v-row>
                          <v-col cols="5"> Upload Video Thumbnail </v-col>
                          <v-col cols="7">
                            <v-icon @click="LivestreamonVideoButtonClick"
                              >mdi-file-upload</v-icon
                            >

                            <input
                              ref="uploader"
                              class="d-none"
                              type="file"
                              accept="video/*"
                              @change="LivestreamonVideoFileChanged"
                            />
                            <v-chip
                              class="mx-3"
                              color="primary"
                              @click:close="Livestreamclosechip()"
                              close
                              outlined
                              v-show="Livestreamchip1"
                              pill
                              >{{
                                this.LivestreamUploadedVideofileName
                              }}</v-chip
                            >
                          </v-col>
                        </v-row>
                        <!------------------------Upload Cover Image------------------>
                        <v-row>
                          <v-col cols="5"> Upload Cover Image </v-col>
                          <v-col cols="7">
                            <v-icon @click="LivestreamonImageButtonClick"
                              >mdi-file-upload</v-icon
                            >

                            <input
                              ref="uploader"
                              class="d-none"
                              type="file"
                              accept="image/*"
                              @change="LivestreamonImageFileChanged"
                            />
                            <v-chip
                              class="mx-3"
                              color="primary"
                              @click:close="LivestreamImageclosechip()"
                              close
                              outlined
                              v-show="LivestreamImagechip1"
                              pill
                              >{{
                                this.LivestreamUploadedImagefileName
                              }}</v-chip
                            >
                          </v-col>
                        </v-row>
                        <!------------------------Upload PDF------------------>
                        <v-row>
                          <v-col cols="5"> Upload PDF </v-col>
                          <v-col cols="7">
                            <v-icon @click="LivestreamonPDFButtonClick"
                              >mdi-file</v-icon
                            >

                            <input
                              ref="uploader"
                              class="d-none"
                              type="file"
                              accept="application/pdf"
                              @change="LivestreamonPDFFileChanged"
                            />
                            <v-chip
                              class="mx-3"
                              color="primary"
                              @click:close="LivestreamPDFclosechip()"
                              close
                              outlined
                              v-show="LivestreamPDFchip1"
                              pill
                              >{{ this.LivestreamUploadedPDFfileName }}</v-chip
                            >
                          </v-col>
                        </v-row>
                      </div>

                      <div class="mt-9 mb-3">Comments</div>
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Add a comment..."
                        single-line
                        hide-details
                        value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                      ></v-textarea>
                    </div>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="#5F6062"
                        outlined
                        @click="LivestreamDialog = false"
                      >
                        Canel
                      </v-btn>

                      <v-btn
                        color="primary"
                        depressed
                        @click="LivestreamDialog = false"
                      >
                        Save Stream
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!----------------------------------------------------------------->
              </v-card>
              <v-card
                class="my-6 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <span class="h1_tab2">Prerequisites</span>
                <div>
                  <div>
                    <v-btn
                      class="mt-9"
                      color="primary"
                      depressed
                      @click="prerequisitesDialog = true"
                    >
                      <span class="text_style">Choose prerequisites</span>
                    </v-btn>
                  </div>
                </div>

                <v-dialog v-model="prerequisitesDialog" max-width="1100" persistent>
                  <v-card rounded="4" class="pa-11">
                    <v-card-title class="text-h5 px-5 mb-6">
                      Choose Prerequisites
                    </v-card-title>
                    <div class="pl-5" v-show="prerequisitescourses">
                      Choose Prerequisites
                    </div>

                    <div v-show="prerequisites">
                      <div class="d-flex">
                        <span class="px-5"> ( </span>

                        <v-select
                          outlined
                          color="primary"
                          dense
                          :items="getFilteredCourses(0)"
                          item-text="Title"
                          clearable
                          item-value="Id"
                          v-model="form.PrerequisitesCourseOne"
                          style="width: 10px"
                        ></v-select>

                        <span class="px-5"> or </span>

                        <v-select
                          outlined
                          color="primary"
                          dense
                          :items="getFilteredCourses(1)"
                          v-model="form.PrerequisitesCourseTwo"
                          item-text="Title"
                          clearable
                          item-value="Id"
                          style="width: 10px"
                        ></v-select>
                        <span class="px-5"> or </span>

                        <v-select
                          outlined
                          color="primary"
                          dense
                          :items="getFilteredCourses(2)"
                          v-model="form.PrerequisitesCourseThree"
                          item-text="Title"
                          clearable
                          item-value="Id"
                          style="width: 10px"
                        ></v-select>

                        <span class="px-5"> )</span>
                      </div>
                      <div class="d-flex">
                        <div class="ml-10 mr-2">and</div>
                        <span class="px-2"> ( </span>

                        <v-select
                          outlined
                          color="primary"
                          dense
                          :items="getFilteredCourses(3)"
                          item-text="Title"
                          item-value="Id"
                          clearable
                          v-model="form.PrerequisitesCourseFour"
                          style="width: 10px"
                        ></v-select>

                        <span class="px-3"> or </span>

                        <v-select
                          outlined
                          color="primary"
                          dense
                          clearable
                          :items="getFilteredCourses(4)"
                          v-model="form.PrerequisitesCourseFive"
                          item-text="Title"
                          item-value="Id"
                          style="width: 10px"
                        ></v-select>
                        <span class="px-3"> or </span>

                        <v-select
                          outlined
                          color="primary"
                          dense
                          clearable
                          :items="getFilteredCourses(5)"
                          v-model="form.PrerequisitesCourseSix"
                          item-text="Title"
                          item-value="Id"
                          style="width: 10px"
                        ></v-select>

                        <span class="px-2"> )</span>
                      </div>
                    </div>

                    <div class="mt-10 pl-5">
                      <v-divider style="height: 1px; background: #c4c4c4">
                      </v-divider>
                      <v-card dark class="py-3 px-9" rounded="4" width="367px">
                        <v-btn color="primary" @click="Showprerequisites()"
                          ><span class="text_style">Course</span></v-btn
                        >
                        <span style="color: white" class="px-7">
                          ( )<span class="px-9"> or </span>and
                        </span>
                      </v-card>
                    </div>

                    <v-card-actions class="mt-4">
                      <v-spacer></v-spacer>

                      <v-btn
                        color="#5F6062"
                        text
                        @click="prerequisitesDialog = false"
                      >
                        Cancel
                      </v-btn>

                      <v-btn
                        color="primary"
                        class="px-10 py-5"
                        depressed
                        @click="prerequisitesDialog = false"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>

              <v-card
                class="my-2 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <span class="h1_tab2">Add Video URL </span>

                <v-card class="my-4" flat>
                  <v-text-field
                    label="(Youtube Link)"
                    single-line
                    outlined
                    hide-details
                    dense
                    v-model="form.VideoURL"
                  ></v-text-field>
                </v-card>
                <span class="h1_tab2">Waiver 1 </span>

                <!-----------------for multiple file uploader---------------------------------------------->
                <v-card outlined height="100" class="px-6 mt-4">
                  <div class="d-flex align-center" style="height: 100%">
                    <v-chip
                      color="primary"
                      @click:close="closechip(i)"
                      close
                      outlined
                      pill
                      :key="i"
                      v-for="(c, i) in UploadedfileName"
                      >{{ UploadedfileName[0].name }}</v-chip
                    >
                    <!-- {{ form.WaiverOne }} -->
                  </div>
                </v-card>
                <div>
                  <v-btn
                    class="text_style my-4 px-11"
                    color="primary"
                    outlined
                    @click="onButtonClick"
                    :disabled="UploadedfileName.length > 0"
                  >
                    Upload document</v-btn
                  >
                  <input
                    ref="uploader"
                    class="d-none"
                    type="file"
                    accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                      text/plain, application/pdf,"
                    @change="onFileChanged"
                  />
                </div>
                <!-- <div class="red--text" v-if="$v.form.UploadedfileName.$error">
                  Waiver is required
                </div> -->
                <!-----------------optional Waiver--------------------------------------->
                <div class="mt-4">
                  <span class="h1_tab2"
                    >Waiver 2
                    <span
                      style="font-size: 20px; color: #636364; font-weight: 400"
                    >
                      (optional)</span
                    >
                  </span>

                  <v-card outlined height="100" class="px-6 mt-4">
                    <div class="d-flex align-center" style="height: 100%">
                      <v-chip
                        color="primary"
                        @click:close="closechiptwo(0)"
                        close
                        outlined
                        v-if="
                          UploadedfileNametwo && UploadedfileNametwo.length > 0
                        "
                        pill
                      >
                        {{ UploadedfileNametwo[0].name }}</v-chip
                      >
                      <!-- {{ form.WaiverTwo }} -->
                    </div>
                  </v-card>
                  <div>
                    <v-btn
                      class="text_style my-4 px-11"
                      color="primary"
                      outlined
                      @click="onButtonClicktwo"
                      :disabled="UploadedfileNametwo.length > 0"
                      >Upload document</v-btn
                    >
                    <input
                      ref="uploadertwo"
                      class="d-none"
                      type="file"
                      accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                      text/plain, application/pdf,"
                      @change="onFileChangedtwo"
                    />
                  </div>
                </div>
              </v-card>
              <v-card
                class="my-2 pa-9"
                flat
                color="#FBFBFF"
                style="border: 1px solid #dee3ef"
              >
                <span class="h1_tab2"
                  >Related courses {{ this.GetSelectedRelatedCourses.length }}/3
                </span>

                <v-row class="pa-2">
                  <v-col
                    cols="12"
                    md="4"
                    v-for="(item, index) in GetSelectedRelatedCourses"
                    :key="index"
                  >
                    <div>
                      <v-card
                        class="mb-12 px-4"
                        outlined
                        style="border: 1px solid rgba(8, 8, 22, 0.15)"
                        flat
                      >
                        <v-img
                          height="250"
                          contain
                          :src="item.Thumbnail"
                        ></v-img>

                        <!-- <v-card
                          class=""
                          rounded="circle"
                          color="white"
                          flat
                          style="position: absolute; top: 7px; right: 7px"
                        >
                          <v-icon
                            close
                            color="primary"
                            @click="removeCard(index)"
                            >mdi-close</v-icon
                          >
                        </v-card> -->
                        <div class="py-4 px-2">
                          <span class="content_span">{{ item.Title }}</span>
                          <div>
                            <span class="content_date">{{
                              item.CreatedDate == null
                                ? new Date().toISOString().split("T")[0]
                                : item.CreatedDate.split("T")[0]
                            }}</span>
                          </div>
                          <div class="mt-3">
                            <v-chip color="#E2F2E6" class="px-6">
                              <span class="content_chip">
                                {{ item.Status }}
                              </span></v-chip
                            >
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
                <div class="mt-2">
                  <v-btn
                    @click="Rcontentdialog = true"
                    class="px-6 text_style"
                    outlined
                    style="
                      border: 1px solid rgba(8, 8, 22, 0.15);
                      color: rgba(34, 34, 34, 0.7);
                    "
                    >Add related course</v-btn
                  >
                </div>
                <v-dialog v-model="Rcontentdialog" max-width="900" persistent>
                  <v-card v-if="Rcontentdialog">
                    <div class="px-9 py-2">
                      <div class="my-4">
                        <h1>Related content</h1>
                      </div>
                      <v-row>
                        <v-col cols="8" md="12" sm="6">
                          <v-card flat>
                            <v-text-field
                              dense
                              outlined
                              prepend-inner-icon="mdi-magnify"
                              label="Search"
                              hide-details
                              single-line
                              v-model="search"
                            >
                            </v-text-field>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="headers"
                        :items="GetActiveCoursesList"
                        hide-default-header
                        class="mt-4"
                      >
                        <template v-slot:[`item.images`]="{ item }">
                          <v-card
                            flat
                            color="transparent"
                            style="max-width: fit-content"
                            class="pa-1"
                          >
                            <v-img
                              contain
                              :src="item.Thumbnail"
                              alt="John"
                              height="50"
                              width="80"
                            />
                          </v-card>
                        </template>
                        <template v-slot:[`item.title`]="{ item }">
                          <div>
                            <span class="table_style_one">
                              {{ item.Title }}
                            </span>
                          </div>
                          <div class="my-1">
                            <v-chip
                              v-if="item.Visibility"
                              label
                              color="#£E5F5E6"
                              small
                              class="chips_style"
                            >
                              {{ item.Visibility ? "Published" : "" }}
                            </v-chip>
                            <span class="mx-3 date_time_style">{{
                              item.CreatedDate == null
                                ? new Date().toISOString().split("T")[0]
                                : item.CreatedDate.split("T")[0]
                            }}</span>
                          </div>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                          <v-switch
                            @change="onChange(item)"
                            :input-value="checkIsExist(item.Id)"
                            :disabled="
                            GetSelectedRelatedCourses.length >= 3 &&
                            GetSelectedRelatedCourses.find(
                                (x) => x.Id === item.Id
                              ) == undefined
                            "
                          />
                        </template>
                      </v-data-table>
                    </div>
                    <v-card-actions class="px-9 pb-9">
                      <v-spacer></v-spacer>
                      <v-btn
                        color="#A1A3A8"
                        class="text_style mx-3"
                        outlined
                        @click="dialoagClose()"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="primary"
                        depressed
                        class="px-14 text_style"
                        @click="RelatedContentSend()"
                      >
                        <v-progress-circular
                          indeterminate
                          size="20"
                          class="px-5"
                          color="white"
                          v-show="btnloader"
                        ></v-progress-circular>
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>
            </div>
          </v-card-text>
        </v-tab-item>
        <!---------------------Step 3 Manuals ------------------>
        <v-tab-item value="tab-3">
          <div class="pa-4">
            <v-row>
              <v-col cols="12" md="9">
                <div class="">
                  <v-radio-group
                    v-model="form.HaveDigitalmanual"
                    @change="SetHaveDigitalmanual"
                    class="d-flex"
                    row
                  >
                    <template v-slot:label>
                      <div class="text">
                        Does this course have a digital Manual?
                      </div>
                    </template>
                    <v-radio :value="true" class="d-flex">
                      <template v-slot:label>
                        <span class="mt-2">Yes</span>
                      </template>
                    </v-radio>
                    <v-radio :value="false">
                      <template v-slot:label>
                        <span class="mt-2">No</span>
                      </template>
                    </v-radio>
                  </v-radio-group>
                  <!-- <div
                    class="red--text"
                    v-if="$v.form.HaveDigitalmanual.$error"
                  >
                    Digital manual option required
                  </div> -->
                </div>
                <div v-if="form.HaveDigitalmanual">
                  <v-row>
                    <v-col cols="12" md="5">
                      <div class="mb-2">Select a Manual</div>
                      <v-select
                        dense
                        single-line
                        outlined
                        hide-details
                        prepend-icon=""
                        :items="GetDigitalManuals"
                        item-value="Id"
                        item-text="Title"
                        v-model="form.DigitalManualId"
                        @change="updateDigitalManualFiles"
                      >
                      </v-select>
                      <div
                        class="red--text"
                        v-if="$v.form.DigitalManualId.$error"
                      >
                        Digital Manual Fee is required
                      </div>
                    </v-col>
                    <v-col cols="12" md="5">
                      <div class="mb-2">
                        Set languages available to students
                      </div>
                      <v-select
                        :items="digitalManualFiles"
                        item-text="Language"
                        dense
                        single-line
                        outlined
                        hide-details
                        multiple
                        v-model="form.DigitalManualLanguages"
                      >
                      </v-select>

                      <!-- v-model="form.DigitalManualLanguages" -->

                      <div
                        class="red--text"
                        v-if="$v.form.DigitalManualLanguages.$error"
                      >
                        Language Fee is required
                      </div>
                    </v-col>
                  </v-row>
                  <!-- <v-row
                    v-for="(divthree, index) in divsthree"
                    :key="divthree.id"
                    :divthree="(divthree = index)"
                  >
                    <v-col cols="12" md="5">
                      <div class="mb-2">Select a Manual</div>
                      <v-select
                        dense
                        single-line
                        outlined
                        hide-details
                        prepend-icon=""
                        :items="GetDigitalManuals"
                        item-value="Id"
                        item-text="Title"
                        v-model="form.DigitalManualId"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="5">
                      <div class="mb-2">Set Language</div>
                      <v-select
                        :items="languages"
                        dense
                        single-line
                        outlined
                        hide-details
                        multiple
                        v-model="form.DigitalManualLanguages"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="1">
                      <div class="d-flex justify-center">
                        <v-icon
                          class="mt-10"
                          color="red"
                          @click="deleteRowthree(index)"
                        >
                          mdi-delete</v-icon
                        >
                      </div>
                    </v-col>
                  </v-row> -->
                </div>
                <div class="my-7">
                  <div v-if="form.HaveDigitalmanual == true" class="my-5">
                    <span class="text">
                      Students can access digital manuals in all languages in
                      which they are available. When an Instructor purchases
                      Digital Manuals, the price is determined by the seminar
                      language. If a seminar takes place in a language without a
                      listed price, the price defaults to English pricing.
                      <br />
                      Add pricing for languages below.
                    </span>
                  </div>
                  <div v-if="form.HaveDigitalmanual">
                    <v-row
                      v-for="(languagepriceData, index) in otherLanguagePrice"
                      :key="index"
                    >
                      <v-col cols="12" md="5">
                        <div class="mb-2">Seminar Language</div>
                        <v-select
                          :items="languages"
                          v-model="languagepriceData.DigitalManualLanguages"
                          multiple
                          dense
                          single-line
                          outlined
                          hide-details
                          prepend-icon=""
                          label="[Select language]"
                          :error-messages="
                            $v.otherLanguagePrice.$each[index]
                              .DigitalManualLanguages.$error
                              ? 'hello'
                              : null
                          "
                        >
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="5">
                        <div class="mb-2">Digital Manual Price</div>
                        <v-text-field
                          v-model="languagepriceData.DigitalManualInstructorFee"
                          dense
                          single-line
                          outlined
                          hide-details
                          type="number"
                          label="[Enter fee in USD]"
                          :error-messages="
                            $v.otherLanguagePrice.$each[index]
                              .DigitalManualInstructorFee.$error
                              ? 'hello'
                              : null
                          "
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        v-if="otherLanguagePrice.length > 1"
                        cols="12"
                        md="1"
                      >
                        <div class="d-flex justify-center">
                          <v-icon
                            class="mt-10"
                            color="red"
                            @click="deleteOtherLanguagePrice(index)"
                          >
                            mdi-delete</v-icon
                          >
                        </div>
                      </v-col>
                    </v-row>

                    <div class="text_trans">
                      <v-btn text @click="addLanguagePrice" color="primary">
                        <span class="text_trans">+ Add language price</span>
                      </v-btn>
                    </div>
                  </div>
                  <div class="my-2">
                    <div class="my-5">
                      <span class="text">
                        For Instructors who do NOT pay a digital manual fee but
                        instead pay an agreed-to royalty rate, add them here:
                      </span>
                    </div>
                    <div>
                      <v-row
                        v-for="(
                          instructorData, index
                        ) in form.CourseInstructors"
                        :key="index"
                      >
                        <v-col cols="12" md="5">
                          <div class="mb-2">Add Instructor</div>
                          <v-select
                            :items="GetAllInstructorsIDsAndNames"
                            item-text="Name"
                            item-value="Id"
                            v-model="instructorData.InstructorId"
                            dense
                            single-line
                            outlined
                            hide-details
                            prepend-icon=""
                            @change="
                              handleSelectChange(
                                instructorData.InstructorId,
                                index
                              )
                            "
                            label="Dropdown"
                            ></v-select>
                            <!-- :error-messages="
                              getInstructorErrorMessage(index, 'InstructorId')
                            " -->
                        </v-col>
                        <v-col cols="12" md="5">
                          <div class="mb-2">Percentage per Student</div>
                          <v-text-field
                            v-model="instructorData.StudentFee"
                            dense
                            single-line
                            outlined
                            hide-details
                            type="number"
                            label="[Enter fee USD]"
                            ></v-text-field>
                            <!-- :error-messages="
                              getInstructorErrorMessage(index, 'StudentFee')
                            " -->
                        </v-col>
                        <v-col cols="12" md="1" v-if="index > 0">
                          <div class="d-flex justify-center">
                            <v-icon
                              class="mt-10"
                              color="red"
                              @click="deleteOtherInstructorArray(index)"
                            >
                              mdi-delete
                            </v-icon>
                          </div>
                        </v-col>
                      </v-row>
                    </div>

                    <div class="text_trans">
                      <v-btn text @click="addAnotherInstructor" color="primary">
                        <span class="text_trans">+ Add another Instructor</span>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="my-7">
                  <span class="text">
                    When Instructors purchase their digital manuals or pay their
                    royalties, digital manuals will be released to student
                    accounts. All students receive the digital manual regardless
                    of whether the Instructor pays a manual fee or a royalty
                    fee.
                  </span>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>

        <v-tab-item value="tab-4">
          <PreviewNewCourseComponent
            :previewNewCouseData="form"
            :PreviewEditCouseImages="PreviewImg"
            :previewBannerNewCouseData="form.Banner"
            :selectedPermissions="form.selectedPermissions"
            :otherLanguagePrice="otherLanguagePrice"
          >
          </PreviewNewCourseComponent>
        </v-tab-item>
      </v-tabs>
    </div>
    <v-divider class="my-6"></v-divider>
    <v-card flat class="d-flex justify-end mb-9">
      <v-btn
        v-if="continuebtn == false"
        @click="send('Save Draft')"
        color="primary"
        class="px-9 py-2 text_style"
        :disabled="btnloader"
      >
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-if="btnloader && IsPublished == false"
        ></v-progress-circular>
        <span v-else>Save Draft</span></v-btn
      >
      <v-btn
        color="primary"
        class="px-9 py-2 text_style"
        @click="changeTab()"
        v-if="continuebtn == true"
        >Continue</v-btn
      >
      <!-- v-if="continuebtn == false" -->
      <v-btn
        color="primary"
        class="px-9 py-2 text_style ml-3"
        v-if="continuebtn == false"
        @click="send('Publish now')"
        :disabled="btnloader"
      >
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-if="btnloader && IsPublished"
        ></v-progress-circular>
        <span v-else> Publish now </span>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import BlogimageuploaderComponent from "./blogimageuploader.component.vue";
import BlogtextediterComponent from "./blogtextediter.component.vue";
import PreviewNewCourseComponent from "./PreviewNewCourse.component.vue";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
//import MunaulRoyalties from "./munaulRoyalties.vue";

export default {
  components: {
    BlogimageuploaderComponent,
    BlogtextediterComponent,
    PreviewNewCourseComponent,
    //MunaulRoyalties,
    SuccessToastComponent,
    ErrorToastComponent,
  },
  name: "NewCoursesComponent",
  computed: {
    ...mapGetters([
      "GetActiveCoursesList",
      "GetLoggedInUser",
      "GetSelectedRelatedCourses",
      "getMembership",
      "GetCourseCategories",
      "GetCourses",
      "GetEditCourse",
      "GetDigitalManuals",
      "GetAllInstructorsIDsAndNames",
    ]),
    filteredMembership() {
      return this.getMembership?.filter((item) => item.Name !== "Life Science");
    },
    getFilteredCourses() {
      const selectedCourses = [
        this.form.PrerequisitesCourseOne,
        this.form.PrerequisitesCourseTwo,
        this.form.PrerequisitesCourseThree,
        this.form.PrerequisitesCourseFour,
        this.form.PrerequisitesCourseFive,
        this.form.PrerequisitesCourseSix,
      ];

      return (selectedCourseIndex) => {
        const coursesToExclude = selectedCourses.slice();
        coursesToExclude.splice(selectedCourseIndex, 1);

        return this.GetActiveCoursesList?.filter(
          (course) => !coursesToExclude.includes(course.Id)
        );
      };
    },
  },
  updated() {},
  async mounted() {
    const obj= {
      page: 1,
      pageSize: "all"
    }
    this.$store.dispatch("GetActiveCoursesList",obj)
    await this.fetchData();
    this.form = this.GetEditCourse;
    // if(this.form.CategoryIds.length > 0){
    //   this.form.filterCategory = this.form.CategoryIds
    // }
    this.form.Content = this.form.Description;
    if(this.form.VideoUrl){
      this.form.VideoURL = this.form.VideoUrl
    }
    this.PreviewImg.showBannerInPreview = this.form.Banner;
    this.PreviewImg.showThumbnailInPreview = this.form.Thumbnail;
    this.PreviewImg.showImg1InPreview = this.form.Image1;
    this.PreviewImg.showImg2InPreview = this.form.Image2;
    this.PreviewImg.showImg3InPreview = this.form.Image3;
    // this.form.selectedPermissions = this.form.Permissions;
    this.form.PrerequisitesCourseOne = this.GetEditCourse?.PrerequisitesCourseOne?.Id
        this.form.PrerequisitesCourseTwo = this.GetEditCourse?.PrerequisitesCourseTwo?.Id
        this.form.PrerequisitesCourseThree = this.GetEditCourse?.PrerequisitesCourseThree?.Id
        this.form.PrerequisitesCourseFour = this.GetEditCourse?.PrerequisitesCourseFour?.Id
        this.form.PrerequisitesCourseFive = this.GetEditCourse?.PrerequisitesCourseFive?.Id
        this.form.PrerequisitesCourseSix = this.GetEditCourse?.PrerequisitesCourseSix?.Id
    if (this.GetEditCourse.CourseInstructors.length == 0) {
      this.addAnotherInstructor();
    }
    if (this.form.WaiverOne) {
      const listOne = this.form?.WaiverOne?.split("_");
      this.UploadedfileName = [
        {
          name: listOne[listOne.length - 1],
        },
      ];
    }
    if (this.form.WaiverTwo) {
      const listTow = this.form?.WaiverTwo?.split("_");
      this.UploadedfileNametwo = [
        {
          name: listTow[listTow.length - 1],
        },
      ];
    }
    await this.GetEditCourse.CourseInstructors.forEach((item, index) => {
      this.handleSelectChange(item.InstructorId, index);
    });
    this.form.Id = this.GetEditCourse.Id;
    this.form.DigitalManual = this.GetDigitalManuals.Id;
    this.form.IsBeginner = this.GetEditCourse.IsBeginner;
    this.form.SubmittedBy = this.GetLoggedInUser.Id;
    if (this.GetEditCourse) {
      this.form = this.GetEditCourse;
      await  this.form.CourseMemberDiscount.forEach((item)=>{
        if(item.Retaking){
          this.selectList.push(item)
        }else{
          this.selectListone.push(item)
        }
      })
      this.relatedCourses = this.GetSelectedRelatedCourses;
      this.form.GraduationTemplate = this.GetEditCourse.GraduationTemplate;
      this.form.DigitalManualLanguages =
        this.GetEditCourse.DigitalManualLanguages?.split(",");
      // this.digitalManualFiles = this.GetEditCourse.DigitalManualLanguages;
      const selectedManual = this.GetDigitalManuals.find(
        (manual) => manual.Id === this.GetEditCourse.DigitalManualId
      );
      if (selectedManual) {
        this.digitalManualFiles = selectedManual.DigitalManualFiles;
      }
      if (
        this.form.PrerequisitesCourseOne != null ||
        this.form.PrerequisitesCourseTwo ||
        this.form.PrerequisitesCourseThree ||
        this.form.PrerequisitesCourseFour ||
        this.form.PrerequisitesCourseFive ||
        this.form.PrerequisitesCourseSix
      ) {
        this.prerequisites = true;
      }
    } else {
      this.$router.push("/courses");
    }
    if (this.GetEditCourse.CourseSeminars.length != 0) {
      this.GetEditCourse.CourseSeminars = this.GetEditCourse.CourseSeminars.map(
        (item) => ({
          ...item,
          DigitalManualLanguages: item.DigitalManualLanguages.split(","),
          DigitalManualInstructorFee: item.DigitalManualInstructorFee,
        })
      );
      this.otherLanguagePrice = this.GetEditCourse.CourseSeminars;
      console.log("this.otherLanguagePrice ", this.otherLanguagePrice);
    }
  },

  data() {
    return {
      seachTimer: 0,
      IsPublished: false,
      imageUrl:
        "http://ibaapis.rootpointers.net/Images/Courses/Banners/e6eb36ca-9c94-4a9d-a8c0-b75043c287fe_dlBinAjax.png",

      base64Image: "",
      IbaUrl: process.env.VUE_APP_IMG_URL,
      InstructorsArray: [],
      PreviewImg: {
        showBannerInPreview: "",
        showThumbnailInPreview: "",
        showImg1InPreview: "",
        showImg2InPreview: "",
        showImg3InPreview: "",
      },
      digitalManualFiles: [],
      userLevel: [
        { name: "Starter", id: 1 },
        { name: "Access", id: 2 },
        { name: "Standard", id: 3 },
        { name: "Practitioner", id: 4 },
        { name: "Instructor", id: 5 },
        { name: "LifeScience", id: 6 },
        { name: "Deceased", id: 7 },
        { name: "InActive", id: 8 },
        { name: "Trainee Instructor", id: 9 },
        { name: "Senior Instructor", id: 10 },
      ],
      languages: [
        "English",
        "Japanese",
        "French",
        "German",
        "Portuguese",
        "Czech",
        "Filipino",
      ],
      // UploadedfileName: [],
      HaveDigitalmanual: "",
      DigitalManual: "",
      Language: "",
      Fee: "",
      search: "",
      SuccessToast: false,
      ErrorToast: false,
      selectedOptions: [],
      selectList: [],
      selectListone: [],
      switch1: true,
      selectedBlog: [],
      headers: [
        { text: "", value: "images" },
        { text: "", value: "title" },

        { text: "", value: "actions", sortable: false },
        {
          text: "",
          value: "",
          sort: function (a, b) {
            if (a ^ b) {
              return a && !b ? -1 : 1;
            } else {
              return 0;
            }
          },
        },
      ],
      DigitalManualLanguages: [],
      CourseSeminars: [],
      prerequisites: false,
      prerequisitescourses: true,
      MemberArray: [],
      div: 0,
      divs: [],
      div1: 0,
      divs1: [],
      divstwo: null,
      divsthree: null,
      showMessage: true,
      bannerStatus: true,
      Livestreamchip1: false,
      LivestreamImagechip1: false,
      LivestreamPDFchip1: false,
      LivestreamDialog: false,
      LivestreamSelection: [],
      selectedFile: null,
      otherinstructorArray: [],
      DivNewCourse: 0,
      otherLanguagePrice: [
        { DigitalManualLanguages: [], DigitalManualInstructorFee: "" },
        // ... Additional fields ...
      ],
      chip1: false,
      isSelecting: false,
      isSelectingtwo: false,
      UploadedfileName: [],
      UploadedfileNametwo: [],
      LivestreamUploadedVideofileName: [],
      LivestreamUploadedImagefileName: [],
      LivestreamUploadedPDFfileName: [],
      GraduationTemplate: "",
      GraduationTemplateArray: [
        "Access",
        "Fundamentals",
        "Advanced Mods",
        "General",
        "MindScape",
        "BreakThrough",
        "FreeFall",
      ],
      prerequisitesDialog: false,
      items: "",
      btnloader: false,
      Rcontentdialog: false,
      continuebtn: true,
      tab: "tab-1",
      chipsvalue: null,
      chips: [],
      selection: 1,
      AssigninstructorsArray: [],

      selectedLanguage: "English",
      LanguageArray: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      selectedLevel: "Beginner (default)",
      LevelsArray: [
        "Beginner (default)",
        "Entry-Level Training",
        "Intermediate Training",
        "Advanced Training",
        "Very Advanced Training",
      ],
      VisibilityArray: ["Visible", "Not Visible"],
      permissionsArray: [
        "Free",
        "Access",
        "Life Science ",
        "Standard ",
        "Practitioner",
        "Instructor",
      ],
      visible: ["Hide", "Show"],

      filterCategoryArray: [
        "Anatomy and Physiology",
        "AnimalTalk",
        "BodyTalk Access",
        "BodyTalk Courses",
        "BreakThrough",
        "CEUs",
        "Conferences",
        "Courses LS",
        "FREE Courses",
        "FSI",
        "Group Sessions",
      ],
      selectedPermissions: [],
      selectedMember: [],
      memberDiscount: "",
      form: {
        CourseInstructors: [
          {
            InstructorId: null,
            StudentFee: null,
          },
        ],
        PrerequisitesCourseOne: null,
        PrerequisitesCoursetwo: null,
        PrerequisitesCoursethree: null,
        PrerequisitesCoursefour: null,
        PrerequisitesCoursefive: null,
        PrerequisitesCoursesix: null,
        Id: 0,
        Title: "",
        Banner: null,
        GraduationTemplate: "",
        Thumbnail: null,
        Image1: null,
        Image2: null,
        Image3: null,
        Image1File: null,
        Image2File: null,
        Image3File: null,
        Image1Path: "",
        Image2Path: "",
        Image3Path: "",
        Content: "",
        SubmittedBy: "",
        Visibility: "",
        subHeading: "",
        Permissions: [],
        selectedPermissions: [],
        HaveDigitalmanual: null,
        DigitalManualId: null,
        DigitalManualLanguages: [],
        DigitalManualInstructor: [],
        filterCategory: [],
        DigitalManual: "",
        CourseFee: "",
        CEUs: "",
        DisplayOrder: "",
        IsBeginner: false,
        VideoURL: "",
        UploadedfileName: null,
        DigitalManuaLanguages: [],
      },
      relatedContentArray: [
        {
          index: 1,
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
      ],
    };
  },
  // created() {
  //   // Assuming CourseSeminars is an array of objects with seminarLanguage and digitalManualPrice properties
  //   this.otherLanguagePrice = CourseSeminars.map((item) => ({
  //     seminarLanguage: item.seminarLanguage || [],
  //     digitalManualPrice: item.digitalManualPrice || "",
  //   }));
  // },
  validations: {
    otherLanguagePrice: {
      $each: {
        DigitalManualLanguages: {
          required,
        },
        DigitalManualInstructorFee: {
          required,
        },
      },
    },
    form: {
      Title: {
        required,
      },
      subHeading: {
        required,
      },
      Banner: {
        required,
      },
      Thumbnail: {
        required,
      },
      filterCategory: {
        required,
      },
      Content: {
        required,
      },
      DisplayOrder: {
        required,
      },
      selectedPermissions: {
        required,
      },
      CEUs: {
        required,
      },

      GraduationTemplate: {
        required,
      },
      UploadedfileName: {
        required,
      },
      CourseFee: {
        required,
      },
      DigitalManualId: {
        required,
      },
      DigitalManualLanguages: {
        required,
      },
      HaveDigitalmanual: {
        required,
      },
      CourseInstructors: {
        $each: {
          InstructorId: {
            required,
          },
          StudentFee: {
            required,
          },
        },
      },
    },
  },
  watch: {
    selectedPermissions() {
      this.selectedMember = this.getMembership.reduce((selected, obj) => {
        if (this.selectedPermissions.includes(obj.Id)) {
          selected.push(obj);
        }
        return selected;
      }, []);
    },
    search() {
      clearTimeout(this.seachTimer);
      this.seachTimer = setTimeout(() => {
        this.getCourse();
      }, 300);
    },
  },
  methods: {
    // getInstructorErrorMessage(index, type) {
    //   return this.$v.form.CourseInstructors.$each[index][type].$error
    //     ? `${type} field is required`
    //     : null;
    // },
    handleSelectChange(selectedValue, index) {
      if (!this.GetAllInstructorsIDsAndNames || !this.form) {
        return;
      }
      const selectedItem = this.GetAllInstructorsIDsAndNames.find(
        (item) => item.Id === selectedValue
      );
      if (selectedItem) {
        const name = selectedItem.Name;
        if (!this.form.DigitalManualInstructor) {
          this.$set(this.form, "DigitalManualInstructor", []);
        }

        this.form.DigitalManualInstructor[index] = name;
      }
    },
    close() {
      this.$emit("close");
    },
    filteredOptions(index) {
      const selected = this.selectList
        .slice(0, index)
        .map((select) => select.selected);

      return this.selectedMember?.filter(
        (member) => !selected.includes(member.Id)
      );
    },
    filteredOptionsone(index) {
      const selectedone = this.selectListone
        .slice(0, index)
        .map((select) => select.selectedone);

      return this.selectedMember?.filter(
        (member) => !selectedone.includes(member.Id)
      );
    },
    updateDigitalManualFiles() {
      // Find the selected manual in the GetDigitalManuals array based on its Id
      const selectedManual = this.GetDigitalManuals.find(
        (manual) => manual.Id === this.form.DigitalManualId
      );

      // If a manual is found, update the digitalManualFiles array with its DigitalManualFiles
      // If a manual is found, update the digitalManualFiles array with its DigitalManualFiles
      if (selectedManual) {
        this.digitalManualFiles = selectedManual.DigitalManualFiles;

        // Reset the selected languages when a new manual is selected
        this.form.DigitalManualLanguages = [];
      } else {
        // If no manual is found, set digitalManualFiles to an empty array
        this.digitalManualFiles = [];

        // Reset the selected languages when no manual is selected
        // this.form.DigitalManualLanguages = [];
      }
    },
    
    addNewSelectone() {
      this.selectListone.push({
        MembershipId: null,
        Percentage: null,
        Retaking: false,
      });
    },
    addNewSelect() {
      this.selectList.push({
        MembershipId: null,
        Percentage: null,
        Retaking: true,
      });
    },
    onChange(obj) {
      this.$store.dispatch("SetRelatedCourses", obj);
    },
    checkIsExist(id) {
      return this.GetSelectedRelatedCourses.some((x) => x.Id === id);

      // this.$store.dispatch("SetRelatedCourses", obj);
    },
    Showprerequisites() {
      this.prerequisites = true;
      this.prerequisitescourses = false;
    },
    async getCourse() {
      const obj = {
        page: 1,
        pageSize: "all",
        search: this.search,
      };
      await this.$store.dispatch("GetActiveCoursesList", obj);
    },
    //  fetchData() {
    //   this.$store.dispatch("GetDigitalManuals");
    // },
    async fetchData() {
      await this.$store.dispatch("GetCourseById", this.$route.params.id);
      this.GetCourseCategories.length == 0 && await this.$store.dispatch("GetCourseCategories");

      await this.$store.dispatch("GetDigitalManuals", {
        page: 1,
        pageSize: "All",
        search: "",
      });
      await this.$store.dispatch("getMembership");
      this.GetAllInstructorsIDsAndNames.length == 0 &&this.$store.dispatch("GetAllInstructorsIDsAndNames")
    },
    addRow() {
      this.divs.push({
        div: this.div,
      });
    },
    RemoveRowMembershipDiscount() {
      this.divs.pop({
        div: this.div,
      });
    },
    addRow1() {
      this.divs1.push({
        div1: this.div1,
      });
    },
    RemoveRowMonitorDiscountone(index) {
      this.selectListone.splice(index, 1);
    },
    RemoveRowMonitorDiscount(index) {
      this.selectList.splice(index, 1);
    },
    Livestreamclosechip() {
      this.Livestreamchip1 = false;
    },
    LivestreamonVideoButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    LivestreamonVideoFileChanged(e) {
      this.Livestreamchip1 = true;
      this.selectedFile = e.target.files[0];
      this.LivestreamUploadedVideofileName = this.selectedFile.name;

      // do something
    },
    LivestreamImageclosechip() {
      this.LivestreamImagechip1 = false;
    },
    LivestreamonImageButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },

    LivestreamonImageFileChanged(e) {
      this.LivestreamImagechip1 = true;
      this.selectedFile = e.target.files[0];
      this.LivestreamUploadedImagefileName = this.selectedFile.name;
      // do something
    },
    LivestreamPDFclosechip() {
      this.LivestreamPDFchip1 = false;
    },
    LivestreamonPDFButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },

    LivestreamonPDFFileChanged(e) {
      this.LivestreamPDFchip1 = true;
      this.selectedFile = e.target.files[0];
      this.LivestreamUploadedPDFfileName = this.selectedFile.name;

      // do something
    },
    // closechip(index) {
    //   var list = [];

    //   for (var i = 0; i < this.UploadedfileName.length; i++) {
    //     if (i != index) {
    //       list.push(this.UploadedfileName[i]);
    //     }
    //   }
    //   this.UploadedfileName = list;
    // },
    closechiptwo(index) {
      var list = [];
      for (var i = 0; i < this.UploadedfileNametwo.length; i++) {
        if (i != index) {
          list.push(this.UploadedfileNametwo[i]);
        }
      }
      this.UploadedfileNametwo = list;
    },

    removeCard(index) {
      this.GetSelectedRelatedCourses.splice(index, 1);
    },
    onButtonClick() {
      if (this.UploadedfileName.length === 0) {
        this.$refs.uploader.click();
      }
    },
    onButtonClicktwo() {
      this.isSelectingtwo = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelectingtwo = false;
        },
        { once: true }
      );

      this.$refs.uploadertwo.click();
    },
    onFileChanged(e) {
      this.UploadedfileName = []; // Clear any previously uploaded files
      if (e.target.files.length > 0) {
        this.UploadedfileName.push(e.target.files[0]); // Add the selected file
        e.target.value = ""; // Clear the input field

        // You can trigger your upload logic here, e.g., send the file to a server.
        // Once the upload is complete, you can handle it as needed.
      }
    },
    closechip(index) {
      this.UploadedfileName.splice(index, 1);
    },
    onFileChangedtwo(e) {
      this.chip1 = true;
      if (e.target.files.length > 0) {
        for (var i = 0; i < e.target.files.length; i++) {
          this.UploadedfileNametwo.push(e.target.files[i]);
        }
        e.target.value = "";
      }

      // do something
    },
    dialoagClose() {
      this.Rcontentdialog = false;
      this.search = "";
      this.getCourse();
    },
    RelatedContentSend() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.Rcontentdialog = false;
        this.btnloader = false;
        this.search = "";
        this.getCourse();
      }, 2000);
    },
    send(status) {
      let CourseMemberDiscount = [...this.selectListone,...this.selectList]
      this.IsPublished = status == "Publish now" ? true : false;
      this.btnloader = true;

      var Form = new FormData();
      this.GetSelectedRelatedCourses.forEach((x) => {
        Form.append("RelatedCourses", x.Id);
      });
      this.form.filterCategory.forEach((x) => {
        Form.append("CategoryId", x);
      });
      if (
        this.UploadedfileName &&
        this.UploadedfileName[0] &&
        this.UploadedfileName[0].size !== undefined
      ) {
        Form.append("WaiverOne", this.UploadedfileName[0]);
      }

      if (
        this.UploadedfileNametwo &&
        this.UploadedfileNametwo[0] &&
        this.UploadedfileNametwo[0].size !== undefined
      ) {
        Form.append("WaiverTwo", this.UploadedfileNametwo[0]);
      }

      Form.append("CEUs", this.form.CEUs);
      Form.append("Currency", "pkr");
      Form.append("DisplayOrder", this.form.DisplayOrder);
      Form.append("Content", this.form.Content);
      Form.append("DigitalManual", this.form.DigitalManual);
      Form.append("IsPublished", this.IsPublished);
      Form.append(
        "DigitalManualId",
        this.form.DigitalManualId ? this.form.DigitalManualId : ""
      );
      Form.append("CourseFee", this.form.CourseFee);
      CourseMemberDiscount.forEach((item, index) => {
        Form.append(`CourseMemberDiscount[${index}].MembershipId`, item.MembershipId);
        Form.append(`CourseMemberDiscount[${index}].Percentage`, item.Percentage);
        Form.append(`CourseMemberDiscount[${index}].Retaking`, item.Retaking);
      });
      this.form.CourseInstructors.forEach((item, index) => {
        if (item.InstructorId) {
          Form.append(
            `CourseInstructors[${index}].InstructorId`,
            item.InstructorId
          );
        } else {
          Form.append(`CourseInstructors[${index}].InstructorId`, 0);
        }
        if (item.StudentFee) {
          Form.append(
            `CourseInstructors[${index}].StudentFee`,
            item.StudentFee
          );
        } else {
          Form.append(
            `CourseInstructors[${index}].StudentFee`,
            0
          );
        }
      });
      this.otherLanguagePrice.forEach((item, index) => {
        // Append DigitalManualLanguages
        const digitalManualLanguagesKey = `CourseSeminars[${index}].DigitalManualLanguages`;
        const digitalManualInstructorFeeKey = `CourseSeminars[${index}].DigitalManualInstructorFee`;
        const digitalManualLanguagesValue = item.DigitalManualLanguages;
        const digitalManualInstructorFeeValue = item.DigitalManualInstructorFee;
        Form.append(digitalManualLanguagesKey, digitalManualLanguagesValue);
        Form.append(
          digitalManualInstructorFeeKey,
          digitalManualInstructorFeeValue
        );
      });
      if (this.form.PrerequisitesCourseOne != null) {
        Form.append("PrerequisitesCourseOne", this.form.PrerequisitesCourseOne);
      }
      if (this.form.PrerequisitesCourseTwo != null) {
        Form.append("PrerequisitesCourseTwo", this.form.PrerequisitesCourseTwo);
      }
      if (this.form.PrerequisitesCourseThree != null) {
        Form.append(
          "PrerequisitesCourseThree",
          this.form.PrerequisitesCourseThree
        );
      }
      if (this.form.PrerequisitesCourseFour != null) {
        Form.append(
          "PrerequisitesCourseFour",
          this.form.PrerequisitesCourseFour
        );
      }
      if (this.form.PrerequisitesCourseFive != null) {
        Form.append(
          "PrerequisitesCourseFive",
          this.form.PrerequisitesCourseFive
        );
      }
      if (this.form.PrerequisitesCourseSix != null) {
        Form.append("PrerequisitesCourseSix", this.form.PrerequisitesCourseSix);
      }
      Form.append("Languages", this.form.DigitalManualLanguages);
      this.form.selectedPermissions?.forEach((x) => {
        Form.append("Permissions", x);
      });
      Form.append("HaveDigitalmanual", this.form.HaveDigitalmanual);
      // this.form.HaveDigitalmanual === "Yes" ? true : false
      //Form.append("CreatedBy", this.form.SubmittedBy);
      Form.append("Id", this.form.Id);
      Form.append("CreatedBy", this.GetLoggedInUser.Id);
      Form.append("filterCategoryname", this.form.filterCategory);
      Form.append("CourseType", 1);

      Form.append("Banner", this.form.Banner);
      Form.append("Thumbnail", this.form.Thumbnail);
      if(this.PreviewImg.showImg1InPreview !== undefined && !this.PreviewImg.showImg1InPreview?.includes('null')){
        if (this.form.Image1File) {
          Form.append("Image1File", this.form.Image1File);
        } else {
          Form.append("Image1Path", this.form.Image1);
        }
      }
      if(this.PreviewImg.showImg2InPreview !== undefined && !this.PreviewImg.showImg2InPreview?.includes('null')){
        if (this.form.Image2File) {
          Form.append("Image2File", this.form.Image2File);
        } else {
          Form.append("Image2Path", this.form.Image2);
        }
      }
      if(this.PreviewImg.showImg3InPreview !== undefined && !this.PreviewImg.showImg3InPreview?.includes('null')){
        if (this.form.Image3File) {
          Form.append("Image3File", this.form.Image3File);
        } else {
          Form.append("Image3Path", this.form.Image3);
        }
      }
      Form.append("IsBeginner", this.form.IsBeginner.toString());
      Form.append("Title", this.form.Title);
      Form.append("VideoURL", this.form.VideoURL);
      Form.append("Description", this.form.Content);
      Form.append("GraduationTemplate", this.form.GraduationTemplate);
      Form.append("SubDescription", this.form.subHeading);
      Form.append("Visibility", this.form.Visibility == "Hide" ? false : true);
      this.$store.dispatch("UpdateCourse", Form).then((res) => {
        if (res.Status) {
          this.$router.push("/courses");
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Edit Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    reserve() {
      this.loading = true;

      setTimeout(() => (this.loading = false), 2000);
    },
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    },
    changeTab() {
      if (this.tab == "tab-1") {
        this.$v.form.Title.$touch();
        this.$v.form.subHeading.$touch();
        this.$v.form.Banner.$touch();
        this.$v.form.Thumbnail.$touch();
        this.$v.form.filterCategory.$touch();
        this.$v.form.Content.$touch();
        if (
          this.$v.form.Title.$invalid ||
          this.$v.form.subHeading.$invalid ||
          this.$v.form.Banner.$invalid ||
          this.$v.form.Thumbnail.$invalid ||
          this.$v.form.filterCategory.$invalid ||
          this.$v.form.Content.$invalid
        ) {
          this.submitStatus = "ERROR";
        } else {
          this.getCourse();
          // var obj = {
          //   title: this.form.Title,
          //   subHeading: this.form.subHeading,
          //   banner: this.form.Banner,
          //   content: this.form.Content,
          //   filterCategory: this.form.filterCategory,
          // };
          this.tab = "tab-2";
        }
      } else if (this.tab == "tab-2") {
        this.$v.form.selectedPermissions.$touch();
        this.$v.form.CEUs.$touch();
        this.$v.form.DisplayOrder.$touch();

        this.$v.form.GraduationTemplate.$touch();
        // this.$v.form.memberDiscount.$touch();
        this.$v.form.UploadedfileName.$touch();
        if (
          this.$v.form.CEUs.$invalid ||
          this.$v.form.selectedPermissions.$invalid ||
          this.$v.form.DisplayOrder.$invalid ||
          this.$v.form.GraduationTemplate.$invalid
        ) {
          this.submitStatus = "ERROR";
        } else {
          // var objdata = {
          //   selectedPermissions: this.form.selectedPermissions,
          //   CEUs: this.form.CEUs,
          //   DisplayOrder: this.form.DisplayOrder,
          //   IsBeginner: this.form.IsBeginner,
          //   memberDiscount: this.form.memberDiscount,
          //   VideoURL: this.form.VideoURL,
          //   GraduationTemplate: this.form.GraduationTemplate,
          // };
          this.tab = "tab-3";
        }
      } else if (this.tab == "tab-3") {
        // this.$v.form.CourseFee.$touch();
        // this.$v.form.DigitalManual.$touch();
        // this.$v.form.HaveDigitalmanual.$touch();
        // this.$v.form.DigitalManualLanguages.$touch();
        // if (
        //   this.$v.form.CourseFee.$invalid &&
        //   this.$v.form.DigitalManual.$invalid &&
        //   this.$v.form.HaveDigitalmanual.$invalid &&
        //   this.$v.form.DigitalManualLanguages.$invalid
        // ) {
        //   this.submitStatus = "ERROR";
        // } else {
        //   // var data = {
        //   //   DigitalManual: this.form.DigitalManual,
        //   //   fee: this.form.CourseFee,
        //   //   languages: this.form.DigitalManualLanguages,
        //   // };
        //   this.tab = "tab-4";
        //   this.continuebtn = false;
        // }
        // this.$v.form.CourseInstructors.$each.$touch();
        // this.$v.form.CourseInstructors.$each.$invalid ||
        if (this.form.HaveDigitalmanual == true) {
          this.$v.otherLanguagePrice.$each.$touch();
          this.$v.form.DigitalManualId.$touch();
          this.$v.form.DigitalManualLanguages.$touch();
          if (  
            this.$v.otherLanguagePrice.$each.$invalid ||
            this.$v.form.DigitalManualId.$invalid ||
            this.$v.form.DigitalManualLanguages.$invalid
          ) {
            return;
          } else {
            this.tab = "tab-4";
            this.continuebtn = false;
          }
        }
        if (this.form.HaveDigitalmanual == false) {
            this.tab = "tab-4";
            this.continuebtn = false;
        }
      } else {
        this.tab = "tab-4";
        this.continuebtn = false;
      }
    },
    SetHaveDigitalmanual() {
      this.$emit("SetHaveDigitalmanual", this.HaveDigitalmanual);
    },
    SetDigitalManual() {
      this.$emit("SetDigitalManual", this.DigitalManual);
    },
    SetLanguage() {
      this.$emit("SetLanguage", this.Language);
    },
    SetFee() {
      this.$emit("SetFee", this.Fee);
    },
    addAnotherInstructor() {
      this.form.CourseInstructors.push({
        InstructorId: null,
        StudentFee: null,
      });
    },
    addLanguagePrice() {
      this.otherLanguagePrice.push({
        DigitalManualLanguages: [],
        DigitalManualInstructorFee: "",
      });
    },
    deleteOtherInstructorArray(index) {
      this.form.CourseInstructors.splice(index, 1);
    },
    deleteOtherLanguagePrice(index) {
      if (this.otherLanguagePrice.length > 1) {
        this.otherLanguagePrice.splice(index, 1);
      }
    },
    deleteRow(index) {
      this.divs.splice(index, 1);
    },
    addRowtwo() {
      this.divstwo.push({
        divtow: this.divtow,
      });
    },
    deleteRowtwo(index) {
      this.divstwo.splice(index, 1);
    },
    addRowthree() {
      this.divsthree.push({
        divthree: this.divthree,
      });
    },
    deleteRowthree(index) {
      this.divsthree.splice(index, 1);
    },
    SetContent(content) {
      this.form.Content = content;
    },
    SetBanner(banner) {
      this.form.Banner = banner.file;
      this.PreviewImg.showBannerInPreview = banner.base64;
    },
    SetThumbnail(thumbnail) {
      this.form.Thumbnail = thumbnail.file;
      this.PreviewImg.showThumbnailInPreview = thumbnail.base64;
    },
    SetImage1(image1) {
      console.log(image1)
      this.form.Image1File = image1.file;
      this.PreviewImg.showImg1InPreview = image1.base64;
    },
    SetImage2(image2) {
      this.form.Image2File = image2.file;
      this.PreviewImg.showImg2InPreview = image2.base64;
    },
    SetImage3(image3) {
      this.form.Image3File = image3.file;
      this.PreviewImg.showImg3InPreview = image3.base64;
    },
  },
};
</script>

<style scoped>
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: #0071bd;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 10px;
}

/*  */
.override-class .v-input {
  display: inline-block;
  width: 100px;
}

h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
}

.tabs_style {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
}

a:hover {
  text-decoration: none;
}

.v-tabs-slider {
  background-color: white !important;
}

.h1_tab2 {
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}

.content_span {
  font-family: " DM Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}

.content_date {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(8, 8, 22, 0.38);
}

.content_chip {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: #54be5a;
}

#no-background-hover::before {
  background-color: transparent !important;
}

@media screen and (max-width: 750px) {
  h1 {
    font-size: 23px;
  }
}

@media screen and (max-width: 430px) {
  .v-application .mx-14 {
    margin-right: 20px !important;
    margin-left: 10px !important;
  }
}
</style>
